export const SET_SELECTED_TERMINAL = "SET_SELECTED_TERMINAL";
export const SET_ALL_DATES = "SET_ALL_DATES";
export const SET_DASHBOARD_USER_TYPE = "SET_DASHBOARD_USER_TYPE";
export const GET_SUMMARY_CARD_STATS = "GET_SUMMARY_CARD_STATS";
export const GET_SUMMARY_CARD_STATS_SUCCESS = "GET_SUMMARY_CARD_STATS_SUCCESS";
export const GET_SUMMARY_CARD_STATS_FAIL = "GET_SUMMARY_CARD_STATS_FAIL";
export const GET_REGISTERED_AGENTS_STATS = "GET_REGISTERED_AGENTS_STATS";
export const GET_REGISTERED_AGENTS_STATS_SUCCESS =
  "GET_REGISTERED_AGENTS_STATS_SUCCESS";
export const GET_REGISTERED_AGENTS_STATS_FAIL =
  "GET_REGISTERED_AGENTS_STATS_FAIL";
export const SET_REGISTERED_DATES = "SET_REGISTERED_DATES";
export const GET_ENABLED_AGENTS_STATS = "GET_ENABLED_AGENTS_STATS";
export const GET_ENABLED_AGENTS_STATS_SUCCESS =
  "GET_ENABLED_AGENTS_STATS_SUCCESS";
export const GET_ENABLED_AGENTS_STATS_FAIL = "GET_ENABLED_AGENTS_STATS_FAIL";
export const SET_ENABLED_DATES = "SET_ENABLED_DATES";
export const SET_REG_STATUS_DATES = "SET_REG_STATUS_DATES";
export const SET_REG_STATUS_REGION = "SET_REG_STATUS_REGION";
export const GET_AGENTS_PER_REG_STATS = " GET_AGENTS_PER_REG_STATS";
export const GET_AGENTS_PER_REG_STATS_SUCCESS =
  "GET_AGENTS_PER_REG_STATS_SUCCESS";
export const GET_AGENTS_PER_REG_STATS_FAIL = "GET_AGENTS_PER_REG_STATS_FAIL";
export const SET_RATIO_DATES = "SET_RATIO_DATES";
export const SET_RATIO_REGION = "SET_RATIO_REGION";
export const GET_AGENTS_RATIO = "GET_AGENTS_RATIO";
export const GET_AGENTS_RATIO_SUCCESS = "SET_AGENTS_RATIO_SUCCESS";
export const GET_AGENTS_RATIO_FAIL = "SET_AGENTS_RATIO_FAIL";
export const SET_REGION_BREAKDOWN_DATES = "SET_REGION_BREAKDOWN_DATES";
export const GET_REGION_BREAKDOWN = "GET_REGION_BREAKDOWN";
export const GET_REGION_BREAKDOWN_SUCCESS = "GET_REGION_BREAKDOWN_SUCCESS";
export const GET_REGION_BREAKDOWN_FAIL = "GET_REGION_BREAKDOWN_FAIL";
export const SET_ADMIN_DATES = "SET_ADMIN_DATES";
export const GET_ADMIN_STATS = "GET_ADMIN_STATS";
export const GET_ADMIN_STATS_SUCCESS = "GET_ADMIN_STATS_SUCCESS";
export const GET_ADMIN_STATS_FAIL = "GET_ADMIN_STATS_FAIL";
